/* * @Author: 曹俊杰 * @Date: 2022-06-08 14:22:37 * @Module: 发布曝光 */
<template>
  <div class="exposureForm">
    <div class="alert">
      <div class="el-icon-ali-jinggao" style="margin-right: 8px"></div>
      <div>
        <span style="color: #262626">你所入录信息在对外展示时都</span
        >会进行脱敏处理，不会造成个人信息泄露
      </div>
    </div>
    <div class="exposureContent">
      <div class="top">
        <div class="title">
          <div class="linesolid"></div>
          曝光来源
        </div>
        <el-form>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="曝光方">
                <el-input :value="user.company?.name" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="曝光账号">
                <el-input :value="user.name" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-form ref="form" :model="form" :rules="rules">
        <div class="center">
          <div class="title">
            <div class="linesolid"></div>
            曝光类型
          </div>
          <div class="typeBox">
            <div
              class="typeItem"
              @click="form.type = 1"
              :class="{ active: form.type == 1 }"
            >
              <div class="typeItem_title">
                <div class="icon"></div>
                <div>违约事实</div>
              </div>
              <div class="typeItem_desc">已经完成合同签约，出现违约情况的</div>
            </div>
            <div
              class="typeItem"
              @click="form.type = 2"
              :class="{ active: form.type == 2 }"
            >
              <div class="typeItem_title">
                <div class="icon"></div>
                <div>高风险人员</div>
              </div>
              <div class="typeItem_desc">疑似有违约可能，或预期有违约可能的</div>
            </div>
            <div
              class="typeItem"
              @click="form.type = 3"
              :class="{ active: form.type == 3 }"
            >
              <div class="typeItem_title">
                <div class="icon"></div>
                <div>其他</div>
              </div>
              <div class="typeItem_desc">其他情形，你认为有录入必要的</div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="title">
            <div class="linesolid"></div>
            曝光信息
          </div>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="违约主播" prop="name">
                <el-input v-model="form.name" placeholder="请输入违约主播姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号" prop="idNumber">
                <el-input
                  v-model="form.idNumber"
                  placeholder="请输入违约主播身份证号码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号" prop="phone">
                <el-input
                  v-model="form.phone"
                  placeholder="请输入违约主播手机号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="content" label="具体情况（最低20字）">
                <el-input
                  :maxlength="100"
                  show-word-limit
                  type="textarea"
                  :rows="5"
                  placeholder="请描述主播违约的情况…"
                  v-model="form.content"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div class="btns">
        <el-button @click="$router.go(-1)">取消</el-button>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import userinfo from "@/mixins/userinfo.js";
export default {
  components: {},
  mixins: [userinfo],
  data() {
    const idCardValidator = (_, value, callback) => {
      if (this.$utils.test.idCard(value)) {
        return callback();
      } else {
        return callback(new Error("请输入正确的身份证号"));
      }
    };
    return {
      form: {
        name: "",
        idNumber: "",
        content: "",
        phone: "",
        type: 1,
      },
      rules: {
        name: [{ required: true, message: "违约主播姓名不能为空", trigger: "blur" }],
        content: [
          { required: true,  min: 20,max: 100, message: "长度控制在 20 - 100 个字符", trigger: "blur" },
        ],
        idNumber: [
          { required: true, message: "违约主播身份证号不能为空", trigger: "blur" },
          { validator: idCardValidator, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
  },
  mounted() {},
  methods: {
    async postExposure() {
      const { status, info } = await this.$api.postExposure(this.form);
      if (status === 200) {
        this.$message({ type: "success", message: info });
        this.$router.go(-1);
      } else {
        this.$message({ type: "error", message: info });
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postExposure();
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.exposureForm {
  // @include contentStyle4;
  @include formStyle;
  .alert {
    border-radius: 2px;
    background: #eff6ff;
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 16px;
    color: #0062ff;
    font-family: "Noto Sans SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    /* 185.714% */
    margin-bottom: 16px;
  }

  .exposureContent {
    min-height: 100vh;
    .title {
      height: 60px;
      opacity: 1;
      display: flex;
      background: #ffffff;
      display: flex;
      align-items: center;
      .linesolid {
        width: 3px;
        height: 16px;
        border-radius: 10px;
        background: #0062ff;
        z-index: 0;
        margin-right: 10px;
      }
    }
    .top,
    .center,
    .bottom {
      padding: 0 16px;
      border-radius: 4px;
      background: #ffffff;
      padding-bottom: 20px;
    }
    .center {
      margin-top: 16px;
      .typeBox {
        display: flex;
        gap: 16px;
        .typeItem {
          width: 100%;
          height: 80px;
          border-radius: 4px;
          opacity: 1;
          background: linear-gradient(90deg, #ffffff 0%, #f8f8f8 100%);

          box-sizing: border-box;
          border: 1px solid #eeeeee;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 6px;
          cursor: pointer;
          &_title {
            display: flex;
            gap: 6px;

            font-size: 14px;
            font-weight: 500;
            color: #262626;
            .icon {
              width: 16px;
              height: 16px;
              background-size: 100% 100%;
              background-image: url(~@/assets/image/exposure/exposure_off.webp);
            }
          }
          &_desc {
            font-size: 12px;
            font-weight: normal;
            line-height: 22px;
            color: #262626;
          }
        }
        .active {
          position: relative;
          border-radius: 4px;
          background: #e8f3ff;
          border: 1.5px solid #1f5aec; /* 保持占位 */

          .typeItem_title {
            .icon {
              background-image: url(~@/assets/image/exposure/exposure_on.webp);
            }
          }
        }
      }
    }
    .bottom {
      margin-top: 16px;
    }
    .btns {
      height: 66px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 16px;
      padding: 0 16px;
      border-radius: 4px;
      background: #ffffff;
    }
  }
}
</style>
